var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-5 flex",attrs:{"fluid":""}},[_c('DataTable',{attrs:{"setup":_vm.selfbuild3dtable,"items":_vm.get_sb3d}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }